import styled from "styled-components";
import {
  Button as AntButton,
  Form as AntForm,
} from "antd";

export const ChangePinContainer = styled.div`
  min-height: calc(100vh - 110px);
  display: flex;
  justify-content: flex-start;
  align-items: left;
  flex-direction: column;
  padding: 20px 16px;

  .ant-form-item-label {
    text-align: center;
    font-size: 16px;
  }

  .ant-input {
    text-align: center;
  }
`;

export const Form = styled(AntForm)`
  width: 100%;
  height: 100%;
  position: relative !important;

  .ant-form-item{
    margin: 0 0 24px 0px;
  }

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 24px;
  }
`;

export const ChangePinTitle = styled.p`
  margin: 0 0 0 24px;
  color: #C21C05;
  font-family: Plus Jakarta Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const SubTitle = styled.p`
  text-align: left;
  margin: 4px 0 24px 24px;
  color: #808080;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const Button = styled(AntButton)`
margin-top: 20px;
  width: 100% !important;
  height: 52px !important;
  border-radius: 27px !important;
  box-sizing: border-box !important ;
  color:  #F7F7F7;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  :hover {
    background-color: #6d1304 !important;
  }
`;

